import { ref, onMounted, onUnmounted, computed } from "vue";

export function useWindowSize() {
  const width = ref(0);
  const height = ref(0);

  const updateSize = () => {
    width.value = window.innerWidth;
    height.value = window.innerHeight;
  };

  onMounted(() => {
    updateSize();
    window.addEventListener("resize", updateSize);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", updateSize);
  });

  return {
    width,
    height,
    isMobile: computed(() => width.value <= 768),
    isTablet: computed(() => width.value > 768 && width.value <= 1024),
    isDesktop: computed(() => width.value > 1024),
  };
}
